import { render } from "./AppLogo.vue?vue&type=template&id=a25ebe46"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppLogo.vue"]])

export default __exports__